import React, { useState, useEffect, Fragment } from "react";
import Select from "react-select";
import { useSelector } from "react-redux";
import _ from "lodash";
import { withStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fade from "@material-ui/core/Fade";
import Switch from "@material-ui/core/Switch";
import Firebase from "../../../firebasehelper";
import { SuperQuestionsSelector } from "../../../redux/reducers";
import { noteOptions } from "../../../Constants/selections";
import { defaultTickeType } from "../constants/default";
import AssignTokenContainer from "../../../components/AssignTokenContainer";
import YesNoChoice from "./YesNoChoice";
import "./TicketTypeForm.css";

const Styles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    width: "95%",
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: 14,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  }),
};

const MySwitch = withStyles({
  switchBase: {
    "&$checked": {
      color: "white",
    },
    "&$checked + $track": {
      backgroundColor: "#60d52d",
    },
  },
  checked: {},
  track: {},
})(Switch);

const TicketTypeForm = ({ onChangeTicket, initial }) => {
  const [ticketType, setTicketType] = useState(defaultTickeType);
  const [loading, setLoading] = useState(false);
  const [loading_script, setLoadingScript] = useState("");
  const superQuestions = useSelector(SuperQuestionsSelector);
  const brand = useSelector((state) => state.brand);
  const [tokenTasks, setTokenTasks] = useState([]);
  useEffect(() => {
    if (brand && brand.name)
      Firebase.getAllTokenEarnings((res) => {
        let tokenTasks = res.filter(
          (token) => token.brand === brand.name || !token.brand
        );
        setTokenTasks(tokenTasks);
      });
  }, [brand]);
  useEffect(() => {
    onChangeTicket(ticketType);
  }, [ticketType]);

  useEffect(() => {
    if (initial) setTicketType(initial);
    else setTicketType(defaultTickeType);
  }, [initial]);
  /*  start of handlers */

  const handleLayerChange = (index, key, value) => {
    const newTicketType = _.cloneDeep(ticketType);
    newTicketType["layers"][index][key] = value;
    setTicketType(newTicketType);
  };

  const handleSetYesNoContent = (content) => {};
  /* end of handlers */

  const addNewLayer = () => {
    const newTicketType = _.cloneDeep(ticketType);
    newTicketType["layers"].push({ type: "" });
    setTicketType(newTicketType);
  };

  const removeAnswer = (index) => {
    const newTicketType = _.cloneDeep(ticketType);
    newTicketType["layers"].splice(index, 1);
    setTicketType(newTicketType);
  };

  const handleChangeActiveness = ({ target }) => {
    const newTicketType = _.cloneDeep(ticketType);
    newTicketType.active = target.checked;
    setTicketType(newTicketType);
  };
  return (
    <div className={`mt-3`} style={{ textAlign: "left", width: "100%" }}>
      <React.Fragment>
        <div className="section-title">
          <h5>Active / Deactive</h5>
          <MySwitch
            checked={ticketType.active}
            onChange={handleChangeActiveness}
            name="activeness"
            inputProps={{ "aria-label": "primary checkbox" }}
          />
        </div>
        {ticketType.layers.map((layer, index) => (
          <React.Fragment key={index}>
            <div className="section-title">
              <h5>Add new layer</h5>
              <p>{index + 1}</p>
            </div>
            <div className="mb-2 layer-item">
              <div className="input-container">
                <Select
                  value={
                    ticketType.layers[index].type
                      ? {
                          label: superQuestions.find(
                            (question) =>
                              question.type === ticketType.layers[index].type
                          ).label,
                          value: ticketType.layers[index].type,
                        }
                      : null
                  }
                  onChange={(value) =>
                    handleLayerChange(index, "type", value.value)
                  }
                  styles={Styles}
                  placeholder="Select a layer type"
                  options={superQuestions.map((question) => ({
                    value: question.type,
                    label: question.label,
                  }))}
                />
              </div>
              <button onClick={() => removeAnswer(index)}>
                <i className="fas fa-trash-alt"></i>
              </button>
            </div>
            {["statement", "question"].includes(
              ticketType.layers[index].type
            ) && (
              <input
                name="statement"
                placeholder={`Input ${ticketType.layers[index].type}`}
                class="form-control form-control-md mb-4"
                autocomplete="off"
                value={ticketType.layers[index].value}
                onChange={({ target }) =>
                  handleLayerChange(index, "value", target.value)
                }
              ></input>
            )}
            {ticketType.layers[index].type === "assign_tokens" && brand && (
              <AssignTokenContainer
                tokenTasks={tokenTasks}
                territory={brand.territory}
                onChange={(payload) =>
                  handleLayerChange(index, "value", payload)
                }
                initialPayload={ticketType.layers[index].value}
              />
            )}
            {ticketType.layers[index].type === "yes_no_choice" && (
              <YesNoChoice
                initialPayload={ticketType.layers[index].value}
                onChange={(payload) => {
                  handleLayerChange(index, "value", payload);
                }}
              />
            )}
          </React.Fragment>
        ))}
      </React.Fragment>
      <Fade
        in={loading}
        style={{
          transitionDelay: loading ? "800ms" : "0ms",
        }}
        unmountOnExit
      >
        <Fragment>
          <p>{loading_script}</p>
          <CircularProgress />
        </Fragment>
      </Fade>
      {!loading && (
        <button
          className={`btn btn-yellow mt-2`}
          type="button"
          onClick={addNewLayer}
        >
          Add new layer
        </button>
      )}
    </div>
  );
};

export default TicketTypeForm;



// WEBPACK FOOTER //
// ./src/screens/Tasks/components/TicketTypeForm.js